import { render, staticRenderFns } from "./WizardChooseRole.vue?vue&type=template&id=f8088e26&scoped=true&"
import script from "./WizardChooseRole.vue?vue&type=script&lang=js&"
export * from "./WizardChooseRole.vue?vue&type=script&lang=js&"
import style0 from "./WizardChooseRole.vue?vue&type=style&index=0&id=f8088e26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8088e26",
  null
  
)

export default component.exports